import { Grid } from '@mui/material';
import TreeChartCommon from 'components/Common/TreeChartCommon';
import { useCallback, useMemo } from 'react';

interface ILandUseSubChart {
  treeData: any;
  areaSetting: (value: any) => string;
  areaUnit: string;
  isLdUse: boolean;
}

export const LandUseSubChart = ({ isLdUse, treeData, areaSetting, areaUnit }: ILandUseSubChart) => {
  const dataPie = useMemo(() => {
    if (!treeData) return [];
    let dataWithPath: any[] = [];
    treeData.forEach((element: any) => {
      // If have museArea, use it, else show landArea
      const nonSlopeData = element.museArea || element.area;
      // Switch data between nonSlopeData and slopeArea
      const area = isLdUse ? nonSlopeData : element.slopeArea;
      const duplicateDataIndex = dataWithPath.findIndex((i) => i.name === element.landUse);
      if (duplicateDataIndex > -1) {
        const indexChild = dataWithPath[duplicateDataIndex].children.findIndex(
          (_item: any) => _item.name === element.category
        );
        // find child with same name and merger value
        if (indexChild > -1) {
          dataWithPath[duplicateDataIndex].children[indexChild] = {
            ...dataWithPath[duplicateDataIndex].children[indexChild],
            value: +areaSetting(area) + +dataWithPath[duplicateDataIndex].children[indexChild].value,
          };
          dataWithPath[duplicateDataIndex] = {
            ...dataWithPath[duplicateDataIndex],
            value: (Number(areaSetting(area)) + Number(dataWithPath[duplicateDataIndex].value)).toString(),
            children: [...dataWithPath[duplicateDataIndex].children],
          };
          return;
        }
        // find child with same landUse and merger value
        dataWithPath[duplicateDataIndex] = {
          ...dataWithPath[duplicateDataIndex],
          value: (Number(areaSetting(area)) + Number(dataWithPath[duplicateDataIndex].value)).toString(),
          children: [
            ...dataWithPath[duplicateDataIndex].children,
            {
              name: element.category,
              value: areaSetting(area),
              path: `${element.landUse}/${element.category}`,
              itemStyle: { color: element.color },
            },
          ],
        };
        return;
      }
      dataWithPath.push(
        element.category
          ? {
              name: element.landUse,
              value: areaSetting(area),
              path: element.landUse,
              itemStyle: { color: element.color },
              children: [
                {
                  name: element.category,
                  value: areaSetting(area),
                  path: `${element.landUse}/${element.category}`,
                  itemStyle: { color: element.color },
                },
              ],
            }
          : {
              name: element.landUse,
              value: areaSetting(area),
              path: element.landUse,
              itemStyle: { color: element.color },
            }
      );
    });

    return dataWithPath;
  }, [areaSetting, isLdUse, treeData]);

  const formatText = useCallback(
    (info: any) => {
      return `${info.name}: ${+info.value} ${areaUnit}`;
    },
    [areaUnit]
  );

  return (
    <>
      {dataPie.length > 0 && (
        <Grid sx={{ mt: 1 }}>
          <TreeChartCommon
            title={`Tree Chart Categories`}
            dataChart={dataPie}
            chartType={'treemap'}
            formatText={formatText}
          />
        </Grid>
      )}
    </>
  );
};
